import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postEditGeneratedInput } from 'api';

// Then, handle actions in your reducers:
const editGeneratedInputSlice = createSlice({
  name: 'editGeneratedInput',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    editGeneratedInputPostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
      state.error = false;
    },
    editGeneratedInputPostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = false;
    },
    editGeneratedInputPostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    editGeneratedInputPostReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  editGeneratedInputPostStart,
  editGeneratedInputPostSuccess,
  editGeneratedInputPostFail,
  editGeneratedInputPostReset,
} = editGeneratedInputSlice.actions;

// The reducer
export const editGeneratedInputReducer = editGeneratedInputSlice.reducer;

// Asynchronous thunk action
export const editGeneratedInputPost = (formData) => (dispatch) => {
  dispatch(editGeneratedInputPostStart());

  postEditGeneratedInput(formData)
    .then((payload) => {
      dispatch(editGeneratedInputPostSuccess(payload));
    })
    .catch((error) => {
      dispatch(editGeneratedInputPostFail(error));
    });
};
